/**
 * Created by guga on 7/29/2016.
 */

import { Injectable }                              from '@angular/core';
import { Http, RequestOptions, Response, Headers } from '@angular/http';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';

import { Token, AuthState } from '../sas-models/index';
import { AuthSas }          from './auth.sas';
import { IHttpHandler }     from '../sas-models/http-handler';

/***********************************************
 * Author : Gustavo(gmm)
 * Date   : 29/07/2016
 *
 * This service is responsible for do authenticated requests using token from AuthService
 * All methods do not check if token is valid (aka not null)
 *
 * Examples of use :
 *
 *   ## GET
 *   this._authHttp.get('yourPath').subscribe(
 *     (res : Response) => console.log('Worked'),
 *     (errorMessage : Response) => console.error('Error')
 *   );
 *
 *   ## POST JSON
 *   this._authHttp.postJson('yourPath', JSON.stringify(yourObject)).subscribe(
 *     (res : Response) => console.log('worked'),
 *     (errorMessage : Response) => console.error('Error')
 *   );
  ***********************************************/

@Injectable()
export class AuthHttpSas implements IHttpHandler {
    private _token : Token;

    public constructor(private _http : Http, private _auth : AuthSas) {
        this._auth.authState$.map((authState : AuthState) => authState.token).subscribe(
            (token : Token) => this._token = token
        );
    }

    private _prepareRequestOptions(options ?: RequestOptions) : RequestOptions {
        if (!this._token)
            return options;

        if (!options) {
            let headers = new Headers({
                'Authorization' : this._token.tokenType + ' ' + this._token.value
            });
            options = new RequestOptions({headers});
        } else {
            options.headers.set('Authorization', this._token.tokenType + ' ' + this._token.value);
        }
        return options;
    }

    public get(url: string, options?: RequestOptions) : Observable<Response> {
        return this._http.get(url, this._prepareRequestOptions(options));
    }

    public post(url: string, body: any, options?: RequestOptions) : Observable<Response> {
        return this._http.post(url, body, this._prepareRequestOptions(options));
    }
    public postJson(url: string, body : string, options?: RequestOptions): Observable<Response> {
        let requestOptions : RequestOptions = this._prepareRequestOptions(options);
        if (requestOptions==null) {
          let headers = new Headers({ 'Content-Type': 'application/json'});
          requestOptions = new RequestOptions({headers : headers});
        }
        else{
          requestOptions.headers.set('Content-Type', 'application/json');
        }
        return this._http.post(url, body, requestOptions);
    }

    public put(url: string, body: any, options?: RequestOptions) : Observable<Response> {
        return this._http.put(url, body, this._prepareRequestOptions(options));
    }
    public putJson(url : string, body : string, options ?: RequestOptions) : Observable<Response> {
        let requestOptions : RequestOptions = this._prepareRequestOptions(options);
        requestOptions.headers.set('Content-Type', 'application/json');

        return this._http.put(url, body, requestOptions);
    }

    public delete(url: string, options?: RequestOptions): Observable<Response> {
        return this._http.delete(url, this._prepareRequestOptions(options));
    }
}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/sas/auth-http.sas.ts